"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../Utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SelectedColors = function SelectedColors(_ref) {
  var selectedColors = _ref.selectedColors,
    handleSelectedColorClick = _ref.handleSelectedColorClick;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selectedColors.map(function (color, index) {
    var isLightOrDark = (0, _Utils.lightOrDark)(color);
    var colorComponent = (0, _Utils.getColorComponentFromRgbaString)(color);
    var isOpacityLow = colorComponent[3] !== undefined && colorComponent[3] < 0.5 ? true : false;
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: function onClick(e) {
        return handleSelectedColorClick(e, color);
      },
      key: index,
      style: {
        backgroundColor: color,
        border: "".concat(isLightOrDark === "dark" || isOpacityLow ? "1px solid #fff" : "1px solid transparent")
      },
      className: "".concat(_Utils.PREFIX_CLASSNAME, "-selected-color")
    });
  }));
};
var _default = SelectedColors;
exports.default = _default;